var _title, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDominantSpeaker = function SvgDominantSpeaker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "dominant-speaker")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 10c1.109 0 2 0.891 2 2s-0.891 2-2 2v6c0 1.094-0.906 2-2 2-2.781-2.312-7.266-5.484-12.688-5.938-1.859 0.625-2.5 2.797-1.281 4.047-1.094 1.797 0.313 3.063 1.969 4.359-0.969 1.906-5 1.937-6.438 0.609-0.906-2.781-2.25-5.563-1.156-9.078h-1.906c-1.375 0-2.5-1.125-2.5-2.5v-3c0-1.375 1.125-2.5 2.5-2.5h7.5c6 0 11-3.5 14-6 1.094 0 2 0.906 2 2v6zM24 19.437v-14.906c-4.078 3.125-8.031 4.922-12 5.359v4.219c3.969 0.438 7.922 2.203 12 5.328z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDominantSpeaker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dominant-speaker.3a99f57e.svg";
export { ForwardRef as ReactComponent };